// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2o-q";
export var animationRelative = "_2o-p";
export var backdropBlur = "_2o-0";
export var detailLabelCell = "_2o-12";
export var detailTable = "_2o-11";
export var detailValueCell = "_2o-13";
export var docIconBox = "_2o-1d";
export var docIconBoxMd = "_2o-1f";
export var docIconBoxSm = "_2o-1e";
export var docTypeRow = "_2o-16";
export var docTypeRowInner = "_2o-17";
export var dropdownMatchDatePicker = "_2o-3";
export var evidenceCardContent = "_2o-1c";
export var fileUploadSpin = "_2o-j";
export var gorgiasOpenButton = "_2o-15 _2o-d";
export var gorgiasTicketCard = "_2o-14";
export var heroModalFooterButton = "_2o-18";
export var hiddenContainer = "_2o-o";
export var iconPrimary = "_2o-1g";
export var iconSecondary = "_2o-1h";
export var iconTertiary = "_2o-1i";
export var integrationCard = "_2o-1";
export var integrationLogoBox = "_2o-2";
export var mainColumnSticky = "_2o-1b";
export var maxWidthContainer = "_2o-19";
export var modalContentBody = "_2o-a";
export var modalHeaderImage = "_2o-5";
export var modalImageLabel = "_2o-7";
export var modalImageOverlay = "_2o-6";
export var modalImageSubtitle = "_2o-9";
export var modalImageTitle = "_2o-8";
export var modalImageWrapper = "_2o-4";
export var modalStickyFooter = "_2o-b";
export var removeButton = "_2o-e";
export var sidebarColumn = "_2o-1a";
export var spinner = "_2o-i";
export var timelineLine = "_2o-y";
export var timelineLineBlack = "_2o-10 _2o-y";
export var timelineLineGray = "_2o-z _2o-y";
export var timelineLineHeight = "_2o-x";
export var tlDotActivate = "_2o-u";
export var tlDotActivateAnim = "_2o-t";
export var tlDotHide = "_2o-s";
export var tlDotHideAnim = "_2o-r";
export var tlLineActivate = "_2o-w";
export var tlLineActivateAnim = "_2o-v";
export var uploadHint = "_2o-n";
export var uploadIconBox = "_2o-k";
export var uploadLabel = "_2o-m";
export var uploadText = "_2o-l";
export var uploadZone = "_2o-f";
export var uploadZoneCursorDefault = "_2o-h";
export var uploadZoneCursorPointer = "_2o-g";
export var uploadedFileRow = "_2o-c";
export var viewButton = "_2o-d";